import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ITestimonials } from 'src/app/interfaces/home.interface';
import { HomeService } from 'src/app/services/home/home.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-testimonial',
  templateUrl: './testimonial.component.html',
  styleUrls: ['./testimonial.component.scss'],
})
export class TestimonialComponent implements OnInit {
  public testimonials!: ITestimonials[];
  constructor(
    private userService: UserService,
    private homeServiceRef: HomeService,
    private route: ActivatedRoute
  ) {}

  getUserImage(obj: ITestimonials, email: string) {
    this.userService.getProfilePic({ emailId: email }).subscribe((res: any) => {
      if (!!res) {
        obj.baseImg = res.base64ProfileImage;
      }
    });
  }

  ngOnInit(): void {
    // const id = this.route.snapshot.paramMap.get('id');
    this.homeServiceRef.getEngagementId().subscribe(enagementId=>{
      const id = enagementId;
      if (id)
        this.homeServiceRef.getTestimonials(id).subscribe((res) => {
          res.forEach((obj: ITestimonials) => {
            this.getUserImage(obj, obj.ownerEmail);
          });
          this.testimonials = res.slice(0,3);
        });
    });
  }
}
